import Vue from "vue";
import toastGenerator from "@/helpers/toastGenerator";
import router from "@/router";

function setHeaders() {
  let user = JSON.parse(localStorage.getItem("user"));
  return { Authorization: "Bearer " + (user ? user.api_token : "") };
}

export default {
  sendGet: (path, data = {}) => {
    return Vue.axios
      .get(path, {
        params: data,
        headers: setHeaders(),
      })
      .catch((error) => {
        if (error.response.status === 401) {
          localStorage.removeItem("user");
          router.push({
            name: "login",
          });
        }
        toastGenerator.errorToast(error.response.data.message);
        return false;
      });
  },
  sendPost: (path, data = {}) => {
    return Vue.axios
      .post(path, data, { headers: setHeaders() })
      .catch((error) => {
        if (error.response.status === 401) {
          localStorage.removeItem("user");
          router.push({
            name: "login",
          });
        }
        toastGenerator.errorToast(error.response.data.message);
        return false;
      });
  },
  sendPut: (path, data = {}) => {
    return Vue.axios
      .put(path, data, { headers: setHeaders() })
      .catch((error) => {
        if (error.response.status === 401) {
          localStorage.removeItem("user");
          router.push({
            name: "login",
          });
        }
        toastGenerator.errorToast(error.response.data.message);
        return false;
      });
  },

  sendDelete: (path, data = {}) => {
    return Vue.axios
      .delete(path, data, { headers: setHeaders() })
      .catch((error) => {
        if (error.response.status === 401) {
          localStorage.removeItem("user");
          router.push({
            name: "login",
          });
        }
        toastGenerator.errorToast(error.response.data.message);
        return false;
      });
  },
};